import { CheckNotes, InspectionCase } from '../../inspection-cases';
import { AlarmCheck } from './alarm-check.dto';
import { ClosedFoamSpraySystems } from './closed-foam-spray-systems.dto';
import { DrySystems } from './dry-systems.dto';
import { EarthquakeReinforcements } from './earthquake-reinforcements.dto';
import { FireExtinguishingSystems } from './fire-extinguishing-systems.dto';
import { FloodingCoolingExtinguishingSystems } from './flooding-cooling-extinguishing-systems.dto';
import { FoamCenterInstallation } from './foam-center-installation.dto';
import { FoamFloodingSystems } from './foam-flooding-systems.dto';
import { PreactionSystemsInstallation } from './preaction-systems-installation.dto';
import { PressureSystem } from './pressure-system.dto';
import { RacksAndReinforcement } from './racks-and-reinforcement.dto';
import { SprinklerSystemInstallationMain } from './sprinkler-system-installation-main.dto';
import { ValvesPlumbingFittings } from './valves-plumbing-fittings.dto';
import { WaterSupplySource } from './water-supply-source.dto';

export class SprinklerSystemInstallationDto extends InspectionCase {
  main?: SprinklerSystemInstallationMain;
  waterSupplySource?: WaterSupplySource;
  fireExtinguishingSystems?: FireExtinguishingSystems;
  pressureSystem?: PressureSystem;
  valvesPlumbingFittings?: ValvesPlumbingFittings;
  preactionSystemsInstallation?: PreactionSystemsInstallation;
  drySystems?: DrySystems;
  floodingCoolingExtinguishingSystems?: FloodingCoolingExtinguishingSystems;
  racksAndReinforcement?: RacksAndReinforcement;
  earthquakeReinforcements?: EarthquakeReinforcements;
  alarmCheck?: AlarmCheck;
  foamCenterInstallation?: FoamCenterInstallation;
  foamFloodingSystems?: FoamFloodingSystems;
  closedFoamSpraySystems?: ClosedFoamSpraySystems;
}
export class SprinklerSystemInstallation extends SprinklerSystemInstallationDto {
  constructor(
    data: SprinklerSystemInstallationDto = {
      title: 'בדיקת התקנת מערכות מתזים במים',
      isApplicable: true
    }
  ) {
    super(data);
    this.main = new SprinklerSystemInstallationMain(data.main);
    this.waterSupplySource = new WaterSupplySource(data.waterSupplySource);
    this.fireExtinguishingSystems = new FireExtinguishingSystems(
      data.fireExtinguishingSystems
    );
    this.pressureSystem = new PressureSystem(data.pressureSystem);
    this.valvesPlumbingFittings = new ValvesPlumbingFittings(
      data.valvesPlumbingFittings
    );
    this.preactionSystemsInstallation = new PreactionSystemsInstallation(
      data.preactionSystemsInstallation
    );
    this.drySystems = new DrySystems(data.drySystems);
    this.floodingCoolingExtinguishingSystems =
      new FloodingCoolingExtinguishingSystems(
        data.floodingCoolingExtinguishingSystems
      );
    this.racksAndReinforcement = new RacksAndReinforcement(
      data.racksAndReinforcement
    );
    this.earthquakeReinforcements = new EarthquakeReinforcements(
      data.earthquakeReinforcements
    );
    this.alarmCheck = new AlarmCheck(data.alarmCheck);
    this.foamCenterInstallation = new FoamCenterInstallation(
      data.foamCenterInstallation
    );
    this.foamFloodingSystems = new FoamFloodingSystems(
      data.foamFloodingSystems
    );
    this.closedFoamSpraySystems = new ClosedFoamSpraySystems(
      data.closedFoamSpraySystems
    );
  }

  setInspectionStatus(): void {
    this.main.setInspectionStatus();
    this.waterSupplySource.setInspectionStatus();
    this.fireExtinguishingSystems.setInspectionStatus();
    this.pressureSystem.setInspectionStatus();
    this.valvesPlumbingFittings.setInspectionStatus();
    this.preactionSystemsInstallation.setInspectionStatus();
    this.drySystems.setInspectionStatus();
    this.floodingCoolingExtinguishingSystems.setInspectionStatus();
    this.racksAndReinforcement.setInspectionStatus();
    this.earthquakeReinforcements.setInspectionStatus();
    // this.alarmCheck.setInspectionStatus();
    this.foamCenterInstallation.setInspectionStatus();
    this.foamFloodingSystems.setInspectionStatus();
    this.closedFoamSpraySystems.setInspectionStatus();

    this.isPassed =
      this.main.isPassed &&
      this.waterSupplySource.isPassed &&
      this.fireExtinguishingSystems.isPassed &&
      this.pressureSystem.isPassed &&
      this.valvesPlumbingFittings.isPassed &&
      this.preactionSystemsInstallation.isPassed &&
      this.drySystems.isPassed &&
      this.floodingCoolingExtinguishingSystems.isPassed &&
      this.racksAndReinforcement.isPassed &&
      this.earthquakeReinforcements.isPassed &&
      (!this.alarmCheck.isApplicable || this.alarmCheck.isPassed) &&
      this.foamCenterInstallation.isPassed &&
      this.foamFloodingSystems.isPassed &&
      this.closedFoamSpraySystems.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.main.getNotes(),
      ...this.waterSupplySource.getNotes(),
      ...this.fireExtinguishingSystems.getNotes(),
      ...this.pressureSystem.getNotes(),
      ...this.valvesPlumbingFittings.getNotes(),
      ...this.preactionSystemsInstallation.getNotes(),
      ...this.drySystems.getNotes(),
      ...this.floodingCoolingExtinguishingSystems.getNotes(),
      ...this.racksAndReinforcement.getNotes(),
      ...this.earthquakeReinforcements.getNotes(),
      ...this.foamCenterInstallation.getNotes(),
      ...this.foamFloodingSystems.getNotes(),
      ...this.closedFoamSpraySystems.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.main.setAsApplicable();
    this.waterSupplySource.setAsApplicable();
    this.fireExtinguishingSystems.setAsApplicable();
    this.pressureSystem.setAsApplicable();
    this.valvesPlumbingFittings.setAsApplicable();
    this.preactionSystemsInstallation.setAsApplicable();
    this.drySystems.setAsApplicable();
    this.floodingCoolingExtinguishingSystems.setAsApplicable();
    this.racksAndReinforcement.setAsApplicable();
    this.earthquakeReinforcements.setAsApplicable();
    this.foamCenterInstallation.setAsApplicable();
    this.foamFloodingSystems.setAsApplicable();
    this.closedFoamSpraySystems.setAsApplicable();
  }
}
